<template>
  <el-drawer
    :visible="visible"
    :close-on-click-modal="false"
    id="vehicleDetails"
    @close="handClose"
  >
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="order">
        <template slot="label"><i class="el-icon-document-checked" style="margin-right:4px"></i>工单详情</template>
        <div class="formTitle">
          {{ order.schedulingNo }} /
          {{ order.status | filterConst("SHIFTORDERSTATUS") }}
        </div>
        <div class="box">
          <div class="item">
            <span class="title">机构名称</span>
            <span class="value">{{ order.organizationName }}</span>
          </div>
          <div class="item">
            <span class="title">线路名称</span>
            <span class="value"
              >{{ order.startStationName }} - {{ order.endStationName }}</span
            >
          </div>
          <div class="item">
            <span class="title">订单类型</span>
            <span class="value">{{
              order.seatType | filterConst("SEATTYPE")
            }}</span>
          </div>
          <div class="item">
            <span class="title">总计金额</span>
            <span class="value" style="color: #ff9900; font-weight: bold"
              >￥{{ order.totalAmount }}</span
            >
          </div>
          <div class="item">
            <span class="title">司机收入</span>
            <span class="value" style="color: #ff9900; font-weight: bold"
              >￥{{ order.realTotalFee }}</span
            >
          </div>
          <br />
          <div class="item">
            <span class="title">出发时间</span>
            <span class="value">{{ order.serviceTime | filterTime }}</span>
          </div>
          <div class="item">
            <span class="title">完成/取消时间</span>
            <span class="value">{{ order.finishTime | filterTime }}</span>
          </div>
        </div>

        <div class="formTitle">车辆信息</div>
        <div class="box">
          <div class="item">
            <span class="title">车辆信息</span>
            <span v-if="order.licenseNo" :style="getPlateStyle(order.licenseNo)">{{ formatPlateNumber(order.licenseNo) }}</span>
            <span v-else class="value">-</span>
          </div>
          <div class="item">
            <span class="title">司机姓名</span>
            <span class="value">{{ order.driverName }}</span>
          </div>
          <div class="item">
            <span class="title">司机电话</span>
            <span class="value">{{ order.driverPhone }}</span>
          </div>
        </div>

        <div class="formTitle">乘客订单</div>

        <!-- <el-button v-show="showDriver" @click="getDriverLocation" plain
          >查看司机实时位置</el-button
        > -->
        <el-table
          style="margin-bottom: 20px"
          border
          empty-text="暂无数据"
          :data="orderVoList"
          @row-click="rowClick"
          ref="mapTable"
          highlight-current-row
        >
          <el-table-column
            v-for="(item, index) in columns"
            :key="index"
            show-overflow-tooltip
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="{ row }">
              <template v-if="item.prop === 'customerName'"
                >用户{{ row.customerPhone.slice(-4) }}
                {{ row.passengerNum }}人</template
              >
              <template v-else-if="item.prop === 'status'">
                <span >{{ row.status | filterConst("CZORDERSUBSTATUS") }}</span>
                
              </template>
              <template v-else-if="item.prop === 'startCity'">
                <div>{{ row.startPointName }}</div>
                <div style="color: #999">
                  {{ row.startCity }}{{ row.startDistrict }}
                </div>
              </template>
              <template v-else-if="item.prop === 'endCity'">
                <div>{{ row.endPointName }}</div>
                <div style="color: #999">
                  {{ row.endCity }}{{ row.endDistrict }}
                </div>
              </template>
              <template v-else-if="item.prop === 'seatType'">
                <div>{{ row.seatType | filterConst("SEATTYPE") }}</div>
              </template>
              <template
                v-else-if="['amount', 'driverAmount'].includes(item.prop)"
              >
                <span class="util-money">￥ {{ row[item.prop] || 0 }}</span>
              </template>
              <template v-else>
                <span>{{ row[item.prop] || "-" }}</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div id="order-map"></div>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>

<script>
import AMap from "AMap";
export default {
  name: "vehicleDetails",
  props: {
    visible: {
      // 显隐
      default() {
        return false;
      },
    },
    order: {
      // 订单
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      tabAction: "order",
      map: null,
      columns: [
        { prop: "orderNo", label: "订单号", width: 200 },
        { prop: "status", label: "订单状态", width: 100 },
        { prop: "startCity", label: "出发地", minidth: 180 },
        { prop: "endCity", label: "目的地", minidth: 180 },
        { prop: "customerName", label: "乘客信息", width: 120 },
        { prop: "seatType", label: "类型", width: 80 },
        { prop: "amount", label: "订单金额", width: 120 },
        { prop: "driverAmount", label: "司机收入", width: 120 },
      ],
      orderVoList: [],
      markerDriver: null,
      markerBegin: null,
      markerBegin1: null,
      markerEnd: null,
      markerEnd1: null,
      showDriver: false,
      driverLocation: null,
      checkRow: false,
    };
  },
  mounted() {
    console.log("mounted");
    this.orderVoList = this.order.orderVos;
    this.showDriver = this.order.status == 40;

    this.$nextTick(() => {
      this.initMap();
      // if (this.showDriver) {
      //   this.getDriverLocation();
      // }
      this.rowClick(this.orderVoList[0]);
    });
  },
  methods: {
    // 地图初始化
    initMap() {
      this.map = new AMap.Map("order-map", {
        mapStyle: "amap://styles/572516903e2f1273ed9c97f54ebacd89",
        resizeEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });
    },
    // 点击行加载标点
    async rowClick(row) {
      console.log("row::: ", row);
      this.checkRow = true;
      this.$refs.mapTable.setCurrentRow(row);

      let markers = [
        {
          pointLat: row.startPointLat,
          pointLng: row.startPointLng,
          pointName: row.startPointName,
          label: "预约起点",
          color: "#4dace2",
          icon: require("@/assets/img/markerBegin.png"),
          key: 'markerBegin'
        },
        {
          pointLat: row.endPointLat,
          pointLng: row.endPointLng,
          pointName: row.endPointName,
          label: "预约终点",
          color: "#47c147",
          icon: require("@/assets/img/markerEnd.png"),
          key: 'markerEnd'
        },
        {
          pointLat: row.realStartPointLat,
          pointLng: row.realStartPointLng,
          pointName: row.realStartPointName,
          label: "实际起点",
          color: "#4dace2",
          icon: require("@/assets/img/markerBegin.png"),
          key: 'markerBegin1'
        },
        {
          pointLat: row.realEndPointLat,
          pointLng: row.realEndPointLng,
          pointName: row.realEndPointName,
          label: "实际终点",
          color: "#47c147",
          icon: require("@/assets/img/markerEnd.png"),
          key: 'markerEnd1'
        },
      ];

      markers.forEach((item) => {
        if (this[item.key]) {
          this[item.key].setMap(null);
        }
        if (item.pointLat && item.pointLng) {
          let content = `<div  style="
                                padding: 10px;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: ${item.color};">
                                <div>${item.label}：${item.pointName}</div>
                            </div>`;
          this[item.key] = new AMap.Marker({
            position: new AMap.LngLat(item.pointLng, item.pointLat),
            icon: item.icon,
            map: this.map,
          });
          this[item.key].setLabel({
            offset: new AMap.Pixel(0, -8),
            content: content,
            direction: "right",
          });
        }
      });
      this.$nextTick(() => {
        this.map.setFitView();
      });
    },
    // 查看司机位置
    async getDriverLocation() {
      if (this.markerDriver) {
        this.markerDriver.setMap(null);
      }
      let url = "/api/V1/manage/order/scheduling/driver/location";
      let params = {
        driverId: this.order.driverId,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        if (data.data) {
          this.markerDriver = new AMap.Marker({
            position: new AMap.LngLat(
              data.data.location.longitude,
              data.data.location.latitude
            ),
            icon: require("@/assets/img/car.png"),
            map: this.map,
          });
          this.map.setCenter([
            data.data.location.longitude,
            data.data.location.latitude,
          ]);
        }
      }
    },
    handClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
#vehicleDetails {
  /deep/.el-drawer {
    overflow: hidden;
    width: 70% !important;
  }
  .link {
    text-decoration: none;
  }
  #order-map {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 430px;
  }
  .el-col {
    margin: 15px 0;
  }
  .box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    font-size: 14px;
    .item {
      width: 33%;
      margin: 15px 0;
      .title {
        display: inline-block;
        width: 100px;
        margin-right: 20px;
      }
      .value {
        color: #999;
        &:empty {
          &::after {
            content: "-";
          }
        }
      }
    }
  }
}
</style>
